import { gql } from '@apollo/client';

const SignupResellerUserWithSubscription = gql`
  mutation signupResellerUserWithSubscription($signed_link: SignedLink!, $input: ResellerUserSignupInput!, $version: Int) {
    signupResellerUserWithSubscription(signedLink: $signed_link, input: $input, version: $version) {
      success
    }
  }
`;

export default SignupResellerUserWithSubscription;
